<script>
	import CreateLotForm from "./CreateLotForm.svelte";
	export let isEdit;
	export let carParkId;
</script>

<CreateLotForm {isEdit} {carParkId} />
